<template>
  <div class="">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :inline="true">
        <FormItem>
          <Select v-model="status"
                  clearable
                  style="width:200px">
            <Option :value="1">已发布</Option>
            <Option :value="0">未发布</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button @click="searchFun()"
                  type="primary">查找</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :inline="true">
        <FormItem>
          <Button @click="showDrawFun(0)"
                  type="success">添加专题</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns1"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer :title="zhuanti_id ? '编辑' : '新增'"
            v-model="showDrawStatus"
            width="600"
            :mask-closable="false">
      <Form :model="zhuanti"
            ref="zhuantiValidate"
            :rules="zhuantiValidate">
        <FormItem label="专题名称"
                  label-position="top"
                  prop="name">
          <Input v-model="zhuanti.name"></Input>
        </FormItem>
        <FormItem label="分享标题"
                  label-position="top"
                  prop="share_title">
          <Input v-model="zhuanti.share_title"></Input>
        </FormItem>
        <FormItem label="分享描述"
                  label-position="top"
                  prop="share_describe">
          <Input type="textarea"
                 v-model="zhuanti.share_describe"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>
        <FormItem label="分享图片"
                  prop="share_thumb">
          <upload-thumb v-model="zhuanti.share_thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="120" :autoCropHeight="120"
                        :defaultTip="'图片格式:jpg、png，建议尺寸120*120，大小不超过10K'"></upload-thumb>
        </FormItem>
        <FormItem label="评论状态"
                  label-position="top"
                  prop="is_comment">
          <div class="">
            <RadioGroup v-model="zhuanti.is_comment">
              <Radio label="1">开启</Radio>
              <Radio label="0">关闭</Radio>
            </RadioGroup>
          </div>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showDrawStatus = false">取消</Button>
        <Button type="primary"
                @click="createFun('zhuantiValidate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>
<script>
import UploadThumb from "../common/thumb";

export default {
  name: "",
  data () {
    const validateThumb = (rule, value, callback) => {
      if (this.$refs["uploadthumb"].uploadList.length == 0) {
        callback(new Error("请上传缩略图"));
      } else {
        callback();
      }
    };
    const validateShareTitle = (rule, value, callback) => {
		// console.log("取值",value)
      if (this.zhuanti.share_title == "") {
        callback(new Error("分享标题必须填写"));
      } else {
        callback();
      }
    };
    const validateShareDesc = (rule, value, callback) => {
      if (this.zhuanti.share_describe == "") {
        callback(new Error("分享描述必须填写"));
      } else {
        callback();
      }
    };
    return {
      status: -1, // 0未发布1已发布
      zhuanti_id: null,
      thumblist: [],
      columns1: [
        {
          title: "专题ID",
          key: "id"
        },
        {
          title: "专题名称",
          key: "name"
        },
        {
          title: "开启评论",
          key: "is_comment",
          render: (h, params) => {
            let is_comment = params.row.is_comment ? '是' : '否'
            return h("div", {}, is_comment)
          }
        },
        {
          title: "发布状态",
          key: "status",
          render: (h, params) => {
            let status = params.row.status ? '是' : '否'
            return h("div", {}, status)
          }
        },
        {
          title: "操作",
          key: "action",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "success",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.bindContent(params.row.id);
                    }
                  }
                },
                "内容"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.commentlist(params.row.id);
                    }
                  }
                },
                "评论"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.showDrawFun(1, params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.removeFun(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ])
          }
        }
      ],
      tablelist: [],
      dataloading: false,
      pages: {
        total: 0,
        current: 1,
        size: 10
      },
      showDrawStatus: false,
      zhuanti: {
        name: "",
        is_comment: "",
        share_title:"",
        share_describe:""
      },
	zhuantiValidate: {
        name: [{ required: true, message: "专题名称必须填写", trigger: "blur" }],
        share_title: [{ required: true, message: "分享标题必须填写", trigger: "blur" }],
        share_describe: [{ required: true, message: "分享描述必须填写", trigger: "blur" }],
        share_thumb: [{ required: true, validator: validateThumb, trigger: "change" }],
        is_comment: [{ required: true, message: "评论开启必须选择", trigger: "blur" }],
      },
    }
  },
  components: {
    UploadThumb
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    this.getTableList()
  },
  methods: {
    // 获取列表
    getTableList () {
      var params = { page: this.pages.current, size: this.pages.size };
      if (this.status != -1) {
        params.status = this.status;
      }
      this.$api.zhuanti.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    // 分页
    changePage () {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.getTableList();
    },
    // 搜索
    searchFun () {
      this.pages.current = 1;
      this.getTableList();
    },
    // 展开添加或编辑
    showDrawFun (status, id) {
      this.showDrawStatus = !this.showDrawStatus;
      this.$refs["zhuantiValidate"].resetFields();
      this.thumblist = new Array();
      if (status == 1) {
        // 编辑
        this.zhuanti_id = id;
        // 详情
        this.$api.zhuanti.detail({ zhuanti_id: id }).then(res => {
          if (res.code == 200) {
            this.zhuanti = {
              name: res.result.name,
              is_comment: String(res.result.is_comment),
              share_title: res.result.share_title,
              share_describe: res.result.share_describe,
              share_thumb: res.result.share_thumb,
            }
            //处理thumb
            if (this.zhuanti.share_thumb != null && this.zhuanti.share_thumb != "") {
              this.thumblist.push({
                name: this.zhuanti.share_thumb,
                url: this.zhuanti.share_thumb,
                status: "finished"
              });
            }
          } else {
            this.$Message.error(res.msg);
          }
        })
      } else {
        // 新增
        this.zhuanti_id = null;
      }
    },
    // 创建专题
    createFun (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.zhuanti.share_thumb = this.$refs["uploadthumb"].uploadList[0].url;
          } else {
            this.zhuanti.share_thumb = null;
          }
          if (this.zhuanti_id) {
            // 编辑
            let params = this.zhuanti;
            params.zhuanti_id = this.zhuanti_id;
            this.$api.zhuanti.edit(params).then(res => {
              if (res.code == 200) {
                this.showDrawStatus = !this.showDrawStatus;
                this.getTableList();

              } else {
                this.$Message.error(res.msg);
              }
            })
          } else {
            // 新增
            this.$api.zhuanti.create(this.zhuanti).then(res => {
              if (res.code == 200) {
                this.showDrawStatus = !this.showDrawStatus;
                this.pages.current = 1;
                this.getTableList();

              } else {
                this.$Message.error(res.msg);
              }
            })
          }

        } else {
          this.$Message.error("请检查输入的信息是否正确！");
        }
      })
    },
    // 删除
    removeFun (id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.zhuanti.remove({ zhuanti_id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            } else {
              this.$Message.error(res.msg);
            }
          });
        }
      });
    },
    // 跳转详情
    bindContent (id) {
      this.$router.push(`/zhuanti/index/${id}`)
    },
    //评论列表
    commentlist (id) {
      this.$router.push(`/zhuanticomment/list/${id}`)
    }
  }
}
</script>